(ns manage.ad-variant.approval.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx ::assign-to-review
  (fn [_ [_ {:keys [adset-id user-ids users message preview-url current-user-name agency-name advertiser-name adset-name]}]]
    ;; TODO: Invalidate queries
    {:fx [[:cqrs/send
           {:type :ad-review/assign-to-review-request
            :data {:request/subject-id adset-id
                   :user-ids user-ids
                   :metadata {:agency {:name agency-name}
                              :advertiser {:name advertiser-name}
                              :adset {:name adset-name}
                              :from-user {:name current-user-name}
                              :email-message message
                              :review-url preview-url
                              :users users}}
            :then [::get-review (js/parseInt adset-id)]
            :catch [::assign-to-review-failed]}]]}))

(rf/reg-event-fx ::revoke-review
  (fn [_ [_ {:keys [request-id user-id adset-id]}]]
    {:fx [[:cqrs/send
           {:type :ad-review/revoke-review-request
            :data {:request/id request-id
                   :user-id user-id}
            :then [::get-review (js/parseInt adset-id)]}]]}))

(rf/reg-event-fx ::get-review
  (fn [_ [_ subject-id]]
    {:fx [[:dispatch [:invalidate-queries-event {:queryKey ["ad-review/get-review" subject-id]}]]
          [:cqrs/send
           {:type :ad-review/get-review
            :data {:request/subject-id subject-id}
            :then [::get-review-success]}]]}))

(rf/reg-event-fx ::get-review-success
  (fn [{:keys [db]} [_ review]]
    {:db (-> db
             (assoc-in [:manage.ad-variant.approval.db :reviewers] (concat (:user-mappings review)
                                                                           (:revoked-users review)))
             (assoc-in [:manage.ad-variant.approval.db :review-creator] (:request/created-by review))
             (assoc-in [:manage.ad-variant.approval.db :review] review))}))

(rf/reg-event-fx ::assign-to-review-failed
  (fn [_]
    {:fx [[:dispatch [:toaster-bus/add {:id :assign-to-review-failed
                                        :type :error
                                        :message "Approval request failed. Please try again or contact support."}]]]}))

(rf/reg-sub ::reviewers
  (fn [db _]
    (get-in db [:manage.ad-variant.approval.db :reviewers])))

(rf/reg-sub ::review
  (fn [db _]
    (get-in db [:manage.ad-variant.approval.db :review])))

(rf/reg-sub ::review-creator
  (fn [db _]
    (get-in db [:manage.ad-variant.approval.db :review-creator])))

(rf/reg-event-fx :manage.ad-variant.approval.db/assign-status
  (fn [_ [_ id new-status subject-id]]
    {:fx [[:cqrs/send
           {:type :ad-review/assign-status
            :data {:request/id id
                   :review-status/status new-status
                   :review-status/subject-id subject-id}}]]}))
